import {
	createFileRoute,
	redirect,
	useNavigate,
	useSearch,
} from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import Cookies from "js-cookie";
import { Library } from "lucide-react";
import { toast } from "sonner";
import { z } from "zod";

import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/login")({
	beforeLoad: async () => {
		const token = Cookies.get("library-refresh-token");
		if (token) {
			throw redirect({ to: "/", replace: true });
		}
	},
	component: RouteComponent,
	validateSearch: zodValidator(
		z.object({
			callback: z.string().optional(),
		}),
	),
});

function RouteComponent() {
	const navigate = useNavigate();
	const { callback } = useSearch({ from: Route.id });

	const client_id = import.meta.env.DEV
		? "library_dxmt_me_dev"
		: "library_dxmt_me";

	const handleDoxmeetLogin = () => {
		const targetUrl = `https://www${
			import.meta.env.DEV ? "-dev" : ""
		}.doxmeet.com/oauth/authorize`;
		const redirectUri = encodeURIComponent(
			`${window.location.origin}/oauth/doxmeet/callback`,
		);
		const popup = window.open(
			`${targetUrl}?client_id=${client_id}&redirect_uri=${redirectUri}&response_type=code&scope=read:user`,
			"oauth",
			"width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no",
		);

		if (popup) {
			// 현재 창에 이벤트 리스너 추가
			const messageHandler = (event: MessageEvent) => {
				if (event.data.type === "oauth-callback") {
					if (event.data.success) {
						navigate({ to: callback ?? "/" });
					} else {
						toast.error(
							"로그인 처리 중 오류가 발생했습니다. 다시 시도해주세요.",
						);
					}
					// 이벤트 리스너 제거
					window.removeEventListener("message", messageHandler);
				}
			};

			window.addEventListener("message", messageHandler);
		}
	};

	return (
		<div className="min-h-screen bg-white flex items-center justify-center p-4">
			<div className="w-full max-w-sm">
				{/* 로고 및 헤더 */}
				<div className="text-center mb-8">
					<div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
						<Library className="w-6 h-6 text-white" />
					</div>
					<h1 className="text-3xl font-semibold text-gray-900 mb-2">
						닥스밋 환자설명자료
					</h1>
					<p className="text-base text-gray-600">
						로그인하여 서비스를 이용하세요
					</p>
				</div>

				{/* 로그인 카드 */}
				<div className="bg-white border border-gray-200 rounded-sm p-6">
					{/* <div className="text-center mb-6">
						<h2 className="text-xl font-medium text-gray-900 mb-1">로그인</h2>
						<p className="text-base text-gray-500">
							닥스밋 계정으로 로그인하세요
						</p>
					</div> */}

					{/* 닥스밋 로그인 버튼 */}
					<Button
						onClick={handleDoxmeetLogin}
						className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-md mb-4"
					>
						<div className="flex items-center justify-center space-x-2">
							<img src="/dmxt_logo_white.svg" alt="doxmeet" className="h-4" />
							<span>닥스밋 계정으로 로그인</span>
						</div>
					</Button>

					{/* 추가 정보 */}
					<div className="text-center">
						<p className="text-sm text-gray-500 font-medium">
							닥스밋 계정이 없으신가요?
							<a
								href="https://www.doxmeet.com/register"
								target="_blank"
								rel="noopener noreferrer"
								className="text-blue-600 hover:text-blue-700 ml-1"
							>
								가입하기
							</a>
						</p>
					</div>
				</div>

				{/* 푸터 */}
				{/* <div className="text-center mt-6">
					<p className="text-xs text-gray-400">
						로그인함으로써
						<a href="/terms" className="text-blue-600 hover:text-blue-700">
							이용약관
						</a>
						과
						<a href="/privacy" className="text-blue-600 hover:text-blue-700">
							개인정보처리방침
						</a>
						에 동의합니다
					</p>
				</div> */}
			</div>
		</div>
	);
}
